export enum StatusCode {
  Preparing = 0,
  Uploading = 1,
  Queued = 2,
  Uploaded = 3,
  Errored = 4
}